import { setTerms } from './helpers';

export const setContract = setTerms('contract');
